import React, { useEffect, useState } from 'react';

// Amounts in pesos as people write them: "1.157.957", "1157957", "1.157.957,50" or "1157957.5".
// A single dot followed by exactly three digits is read as thousands ("1.157" = 1157), since peso
// amounts rarely carry three decimals.
export const parseMoney = (text: string): number | null => {
  const clean = String(text || '').replace(/[\s$]/g, '');
  if (!clean) return null;
  let normalized = clean;
  if (clean.includes(',')) normalized = clean.replace(/\./g, '').replace(',', '.');
  else if ((clean.match(/\./g) || []).length > 1) normalized = clean.replace(/\./g, '');
  else if (/^\d+\.\d{3}$/.test(clean)) normalized = clean.replace('.', '');
  if (!/^\d+(\.\d+)?$/.test(normalized)) return null;
  const value = Number(normalized);
  return Number.isFinite(value) ? Math.round(value * 100) / 100 : null;
};

const formatMoney = (value: number) => value.toLocaleString('es-AR', { minimumFractionDigits: 0, maximumFractionDigits: 2 });

const MoneyInput: React.FC<{ value: number; onChange: (value: number) => void; className?: string; ariaLabel?: string; autoFocus?: boolean; placeholder?: string }> = ({ value, onChange, className, ariaLabel, autoFocus, placeholder }) => {
  const [text, setText] = useState(value ? formatMoney(value) : '');
  // Follow changes made from outside (a suggested amount), without fighting what is being typed.
  useEffect(() => {
    if ((parseMoney(text) ?? 0) !== (value || 0)) setText(value ? formatMoney(value) : '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  const parsed = parseMoney(text);
  const invalid = text.trim() !== '' && parsed === null;
  return (
    <span className="block">
      <input type="text" inputMode="decimal" aria-label={ariaLabel} autoFocus={autoFocus} placeholder={placeholder} value={text}
        onChange={(e) => { setText(e.target.value); onChange(parseMoney(e.target.value) ?? 0); }}
        onBlur={() => { if (parsed !== null) setText(formatMoney(parsed)); }}
        className={`${className || ''} ${invalid ? 'border-red-400' : ''}`} />
      {invalid ? <span className="mt-0.5 block text-[11px] text-red-700">Importe no válido</span>
        : parsed !== null && text !== formatMoney(parsed) ? <span className="mt-0.5 block text-[11px] text-gray-500">= $ {formatMoney(parsed)}</span> : null}
    </span>
  );
};

export default MoneyInput;
